import { useTranslation } from 'react-i18next';
import { ON_CHAIN_GGMOMOMO_LOGO } from '../lib/tokenLogos';

type GgmomomoInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpenPurchase: () => void;
};

export default function GgmomomoInfoModal({
  isOpen,
  onClose,
  onOpenPurchase,
}: GgmomomoInfoModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="ggmomomo-info-modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('ggmomomo.title')}
      >
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('ggmomomo.close')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="ggmomomo-info-identity">
            <img className="ggmomomo-info-logo" src={ON_CHAIN_GGMOMOMO_LOGO} alt="GGMOMOMO logo" />
            <strong>{t('ggmomomo.tokenName')}</strong>
          </div>
          <p className="ggmomomo-info-description">{t('ggmomomo.description')}</p>
          <div className="bbt-info-actions">
            <button className="auth-button ggmomomo-buy-button" type="button" onClick={onOpenPurchase}>
              {t('ggmomomo.buyGgmomomo')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
